<template>
    <el-drawer
        :visible.sync="drawer"
        direction="rtl"
        size="100%">
        <div style="padding: .2rem .3rem">
            <div v-for="item in refundRecord" :key="item.AM5115465165416513">
                <p style="font-size: .3rem;margin-bottom: 10px;">{{ $t('Order.Details.Components.RefundRecordMobile.RufundID') }}: {{ item.refundId }}</p>
                <p style="font-size: .3rem;margin-bottom: 10px;">{{ $t('Order.Details.Components.RefundRecordMobile.RufundTime') }}: {{ getDayjs(item.refundDate).format('YYYY-MM-DD HH:mm:ss') }}</p>
                <p style="font-size: .3rem;margin-bottom: 10px;">{{ $t('Order.Details.Components.RefundRecordMobile.RefundAmount') }}: {{ item.refundAmount }}</p>
                <div class="timelineBox">
                    <el-timeline>
                        <el-timeline-item
                            v-for="(timeItem, index) in item.refunds"
                            :key="index"
                            :type="timeItem.status | typeFilter"
                            :timestamp="showText(timeItem, item)">
                            <span>{{ getDayjs(timeItem.createDate).format('MMM-DD HH:mm:ss A') }}</span>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import API from '@/api'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      drawer: false,
      refundRecord: [
        {
          'refundId': 'AM5115465165416513',
          'refundDate': 165151132203,
          'refundAmount': 165151132203,
          'refunds': [
            {
              'status': 2,
              'createDate': 221121313,
              'refundFailReason': ''
            },
            {
              'status': 1,
              'createDate': 221121313,
              'refundFailReason': ''
            },
            {
              'status': 0,
              'createDate': 221121313,
              'refundFailReason': ''
            }
          ]
        }
      ]
    }
  },
  computed: {
    getDayjs() {
      return dayjs
    }
  },
  filters: {
    typeFilter(value) {
      let type = ''
      if (+value === 0) type = undefined
      if (+value === 1) type = 'primary'
      if (+value === 2) type = 'danger'
      return type
    }
  },
  methods: {
    handleClose() {},
    show(kkOrderId) {
      this.drawer = true
      API.getOrderRefundRecord(kkOrderId).then((res) => {
        this.refundRecord = res.data
      })
    },
    showText(timeItem, item) {
      if (+timeItem.status === 0) return 'Refund Application'
      if (+timeItem.status === 1) return `Refunded Refund Amount $${item.refundAmount}`
      if (+timeItem.status === 2) return `Refund Failed  ${timeItem.refundFailReason}`
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-drawer__header{
    padding: .2rem .3rem 0 0 !important;
    margin: 0 !important;
}
.timelineBox{
    margin-top: 20px;
    border-bottom: 1px solid #CDD4DD;
}
</style>
